module.exports = __webpack_public_path__ + "img/1-1.73162321.png";